export default "__VITE_ASSET__519aad35__"